<div class="flex flex-col h-full">

    <!-- En-tête -->
    <div class="flex items-center border border-gray-300 rounded-t-md bg-gray-50 px-4 py-3">
        <span class="flex-1 text-center font-semibold text-base">{{ 'vues.ipad.quiz.headerTitle' | translate }}</span>
        <span class="w-10 flex justify-center">
            @if (allAnswered()) {
            <i class="fas fa-check text-green-500 text-lg"></i>
            }
        </span>
    </div>

    <!-- Liste des questions (accordéon) -->
    <div class="border-x border-b border-gray-300 rounded-b-md divide-y divide-gray-200 overflow-y-auto max-h-[500px]">
        @for (item of displayedItems; track item.id) {
        <div>
            <!-- Ligne titre (cliquable) -->
            <div class="flex items-center cursor-pointer px-4 py-3 hover:bg-gray-50"
                (click)="toggleExpand(item.id)">
                <span class="mr-2">
                    @if (isExpanded(item.id)) {
                    <i class="fas fa-chevron-down text-sm text-blue-500"></i>
                    } @else {
                    <i class="fas fa-chevron-right text-sm text-blue-500"></i>
                    }
                </span>
                <span class="flex-1 text-blue-600 font-medium" [innerHTML]="getTitle(item)"></span>
                <span class="w-6 flex justify-center">
                    @if (getSelectedAnswer(item.id) !== undefined) {
                    <i class="fas fa-check text-green-500 text-sm"></i>
                    }
                </span>
            </div>

            <!-- Contenu + Réponses (expandé) -->
            @if (isExpanded(item.id)) {
            <div class="px-6 py-4 bg-white border-t border-gray-100">
                <!-- Contenu HTML de la question (optionnel) -->
                @if (getContent(item)) {
                <div class="mb-4 text-gray-700 text-sm" [innerHTML]="getContent(item) | safeHtml"></div>
                }

                <!-- Réponses possibles (radio buttons) -->
                <div class="space-y-2">
                    @for (response of item.children || []; track response.id) {
                    <label class="flex items-center cursor-pointer space-x-3 px-3 py-2 rounded-md hover:bg-gray-50 border border-gray-200"
                        [class.bg-blue-50]="getSelectedAnswer(item.id) === response.id"
                        [class.border-blue-400]="getSelectedAnswer(item.id) === response.id">
                        <input type="radio"
                            [name]="'quiz_q_' + item.id"
                            [checked]="getSelectedAnswer(item.id) === response.id"
                            (change)="selectAnswer(item.id, response.id)"
                            class="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-400 cursor-pointer" />
                        <span class="text-sm text-gray-800">{{ getResponseTitle(response) }}</span>
                    </label>
                    }
                </div>
            </div>
            }
        </div>
        }
    </div>

</div>